import React, { Component } from "react";
import logo from '../../img/logo.png';
import './Login.css';
import axios from "../../util/axios";
import Alertmessage from '../../components/common/alertMessage';
import Field from '../../components/common/Field';
import { trackPromise } from "react-promise-tracker";

import { Validator } from "../../util/Validator";

class reqotp extends Component {

	constructor(props) {
		super(props);
		this.state = {
			username: "",
			isOTPrequested: false,
			otp: "",
			newPassword: "",
			confirmNewPassword: "",
			invalidOTP: false,
			errorMessage: ""
		};
		this.handleChange = this.handleChange.bind(this);
	}
	
	handleChange(event) {
		this.setState({
			[event.target.name] : event.target.value
		});
	};

	handleRequestOTP = async event => {
		const data = {};
		data.username = this.state.username;
		event.preventDefault();
		trackPromise(
			axios.post('api/user/requestOTP', data, {
				headers: {}
			})
			.then(res => {
				if(res.status === 201){
					this.setState({ invalidOTP: false, isOTPrequested: true });
				}
				else console.log("Issue seen in generating OTP");
			})
			.catch(err => {
				if (err.response.data && err.response.data.errorMessage) {
					this.setState({ errorMessage: err.response.data.errorMessage });
				}
				this.setState({ invalidOTP: true });
			})
		);
	};

	handlePasswordReset = async event => {
		event.preventDefault();
		/** API request body*/
		const data = {};
		data.username = this.state.username;
		data.newPassword = this.state.newPassword;
		data.otp = this.state.otp.trim();
		trackPromise(
			axios.put('api/user/resetPassword', data, {
				headers: {}
			})
			.then(res => {
				if(res.status === 200){
					this.setState({ invalidOTP: false });
					localStorage.removeItem('userData');
					localStorage.setItem('userData', JSON.stringify(res.data));
					localStorage.setItem('cobrandId', JSON.stringify(res.data.cobrands[0].id));
					window.location.href = "/"; 
				} 
			})
			.catch(err => {
				if (err.response.data && err.response.data.errorMessage) {
					this.setState({ errorMessage: err.response.data.errorMessage });
				}
				this.setState({ invalidOTP: true });
			})
		);
	};

	render() {
		if (this.state.isOTPrequested) {
			return (
				<React.Fragment>									
					<div className="wrapper login">
						<div id="formContent">
							<div className="">
								<img src={logo} alt="logo" />
							</div>
							{ this.state.invalidOTP && 
								<Alertmessage message={this.state.errorMessage} alertType={'alert-danger'}/>
							}							
							<div className="text-left pad5">
								<h2 className="text-left text-wrap mx-4">Reset Password</h2>
								<p className="text-left text-wrap mx-4">Enter the One Time Passcode (OTP) received in your email and set the new password.</p>
							</div>
							<div className="mb-3">
								<input autoFocus type="text" name="otp" className="" placeholder="Enter OTP" value={this.state.otp} onChange={this.handleChange}/>
							</div>
							<div>
								<Field type="password" name="newPassword" className={Validator.isInvalidPassword(this.state.newPassword) ? "error" : ""} iconClass="fas fa-eye fa-1x pointer" iconBottom="310px" iconLeft="84%" placeholder="New Password" value={this.state.newPassword} onChange={this.handleChange} />
							</div>
							<div className="error">
								<span>
									{ Validator.isInvalidPassword(this.state.newPassword) ? (
											<React.Fragment>{ Validator.passwordCriteria }</React.Fragment>
										) : (
											<React.Fragment>&nbsp;</React.Fragment>
										)
									}
								</span>
							</div>
							<div>
								<Field type="password" name="confirmNewPassword" className={Validator.isPasswordMismatch(this.state.newPassword, this.state.confirmNewPassword) ? "error" : ""} iconClass="fas fa-eye fa-1x pointer" iconBottom="220px" iconLeft="84%" placeholder="Confirm New Password" value={this.state.confirmNewPassword} onChange={this.handleChange} />
							</div>
							<div className="error">
								<span>
									{ Validator.isPasswordMismatch(this.state.newPassword, this.state.confirmNewPassword) ? (
											<React.Fragment>{ Validator.passwordMatchError }</React.Fragment>
										) : (
											<React.Fragment>&nbsp;</React.Fragment>
										)
									}
								</span>
							</div>
							<div>
								<input className="mt-2" type="submit" onClick={this.handlePasswordReset} disabled={Validator.disableSubmitButton(this.state.newPassword, this.state.confirmNewPassword) || this.state.otp.length < 6} value="Set Password" />
							</div>
							<div id="formFooter">
								<a className="underlineHover" href="/">Cancel</a>
							</div>
						</div>
					</div>
				</React.Fragment>
			);
		}
		else if (!this.state.isOTPrequested) {
			return (
				<div className="wrapper login">
					<div id="formContent">
						<div className="">
							<img src={logo} alt="logo" />
						</div>
						{ this.state.invalidOTP && 
							<Alertmessage message={this.state.errorMessage} alertType={'alert-danger'}/>
						}	
						<div className="text-left pad5">
							<h2 className="text-left text-wrap mx-4">Forgot Password</h2>
							<p className="text-left text-wrap mx-4">Give us your Registered Email ID and we shall send you token to reset your password.</p>
						</div>
						<input type="text" name="username" className="" placeholder="Email" value={this.state.username} onChange={this.handleChange}/>
						<input type="submit" className="" value="Request OTP" onClick={this.handleRequestOTP}/>

						<div id="formFooter">
							<a className="underlineHover" href="/">Cancel</a>
						</div>
					</div>
				</div>
			);
		} 
	}

}

export default reqotp;